<template>
  <div class="wrapper">
    <div class="slot">
      <slot></slot>
    </div>

    <pre v-if="!isEmptyData" class="code ml-8">{{ propData }}</pre>
  </div>
</template>

<script setup lang="ts">
import { computed, useSlots } from 'vue';
import { isEmpty } from 'lodash';

const slots = useSlots();

const propData = computed(() => {
  const vnodeList = slots.default?.();
  if (!vnodeList?.length) {
    return {};
  }
  return vnodeList[0].props ?? {};
});

const isEmptyData = computed(() => isEmpty(propData.value));
</script>

<style lang="scss" scoped>
.slot {
  min-width: 200px;
}

.code {
  background-color: #fff;
  padding: 8px;
}

.wrapper {
  display: flex;
  position: relative;

  & + & {
    margin-top: 16px;
  }
}
</style>
